import { addCollection } from '@iconify/vue'
import ic from '@iconify-json/ic/icons.json'
// import ion from '@iconify-json/ion/icons.json'
import mdi from '@iconify-json/mdi/icons.json'
// import solar from '@iconify-json/solar/icons.json'
// import radixIcons from '@iconify-json/radix-icons/icons.json'

export default defineNuxtPlugin(() => {
  // Load commonly-used icon collections locally to avoid runtime fetches/CDN calls
  addCollection(ic)
  // addCollection(ion)
  addCollection(mdi)
  addCollection({
    prefix: 'material-symbols',
    width: 24,
    height: 24,
    icons: {
      add: {
        body: '<path fill="currentColor" d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2z"/>',
      },
      'arrow-back': {
        body: '<path fill="currentColor" d="m7.825 13l5.6 5.6L12 20l-8-8l8-8l1.425 1.4l-5.6 5.6H20v2z"/>',
      },
      check: {
        body: '<path fill="currentColor" d="m9.55 18l-5.7-5.7l1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4z"/>',
      },
      close: {
        body: '<path fill="currentColor" d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6z"/>',
      },
      'help-outline': {
        body: '<path fill="currentColor" d="M11.95 18q.525 0 .888-.363t.362-.887t-.362-.888t-.888-.362t-.887.363t-.363.887t.363.888t.887.362m-.9-3.85h1.85q0-.825.188-1.3t1.062-1.3q.65-.65 1.025-1.238T15.55 8.9q0-1.4-1.025-2.15T12.1 6q-1.425 0-2.312.75T8.55 8.55l1.65.65q.125-.45.563-.975T12.1 7.7q.8 0 1.2.438t.4.962q0 .5-.3.938t-.75.812q-1.1.975-1.35 1.475t-.25 1.825M12 22q-2.075 0-3.9-.787t-3.175-2.138T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8"/>',
      },
      'pending-actions': {
        body: '<path fill="currentColor" d="M17 22q-2.075 0-3.537-1.463T12 17t1.463-3.537T17 12t3.538 1.463T22 17t-1.463 3.538T17 22m1.675-2.625l.7-.7L17.5 16.8V14h-1v3.2zM5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h4.175q.275-.875 1.075-1.437T12 1q1 0 1.788.563T14.85 3H19q.825 0 1.413.588T21 5v6.25q-.45-.325-.95-.55T19 10.3V5h-2v3H7V5H5v14h5.3q.175.55.4 1.05t.55.95zm7-16q.425 0 .713-.288T13 4t-.288-.712T12 3t-.712.288T11 4t.288.713T12 5"/>',
      },
      'progress-activity': {
        body: '<path fill="currentColor" d="M12 22q-2.05 0-3.875-.788t-3.187-2.15t-2.15-3.187T2 12q0-2.075.788-3.887t2.15-3.175t3.187-2.15T12 2q.425 0 .713.288T13 3t-.288.713T12 4Q8.675 4 6.337 6.338T4 12t2.338 5.663T12 20t5.663-2.337T20 12q0-.425.288-.712T21 11t.713.288T22 12q0 2.05-.788 3.875t-2.15 3.188t-3.175 2.15T12 22"/>',
      },
      'shield-question-outline': {
        body: '<path fill="currentColor" d="M12 22q-3.475-.875-5.738-3.988T4 11.1V5l8-3l8 3v6.1q0 3.8-2.262 6.913T12 22m0-2.1q2.6-.825 4.3-3.3t1.7-5.5V6.375l-6-2.25l-6 2.25V11.1q0 3.025 1.7 5.5t4.3 3.3m0-2.9q.425 0 .738-.312t.312-.738t-.312-.737T12 14.9t-.737.313t-.313.737t.313.738T12 17m-.725-3.2h1.5v-.55q0-.275.125-.525q.15-.35.4-.587t.525-.488q.425-.425.738-.95t.312-1.15q0-1.125-.862-1.838T12 7q-1 0-1.787.575T9.15 9.1l1.35.55q.15-.5.563-.85T12 8.45q.55 0 .963.325t.412.825q0 .425-.262.788t-.588.662q-.3.275-.6.563t-.475.662q-.175.35-.175.738z"/>',
      },
    },
  })
  // addCollection(solar)
  // addCollection(radixIcons)

  addCollection({
    prefix: 'custom', // Prefix for your custom icons
    icons: {
      'risk-assessments': {
        body: '<path fill="currentColor" d="m2,12C2,6.48,6.48,2,12,2s10,4.48,10,10-4.48,10-10,10S2,17.52,2,12Zm2,0c0,4.41,3.59,8,8,8s8-3.59,8-8-3.59-8-8-8S4,7.59,4,12Zm8-4.5c-2.49,0-4.5,2.01-4.5,4.5s2.01,4.5,4.5,4.5,4.5-2.01,4.5-4.5-2.01-4.5-4.5-4.5Zm-1,4.5c0,.55.45,1,1,1s1-.45,1-1-.45-1-1-1-1,.45-1,1Z"/>',
        width: 24,
        height: 24,
      },
      certified: {
        body: '<path xmlns="http://www.w3.org/2000/svg" d="M19.07 4.93L17.66 6.34C19.1 7.79 20 9.79 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.92 7.05 4.56 11 4.07V6.09C8.16 6.57 6 9.03 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 10.34 17.33 8.84 16.24 7.76L14.83 9.17C15.55 9.9 16 10.9 16 12C16 14.21 14.21 16 12 16C9.79 16 8 14.21 8 12C8 10.14 9.28 8.59 11 8.14V10.28C10.4 10.63 10 11.26 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 11.26 13.6 10.62 13 10.28V2H12C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 9.24 20.88 6.74 19.07 4.93Z" fill="currentColor"/>',
        width: 24,
        height: 24,
      },
      company: {
        body: '<path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M12 7H22V21H2V3H12V7ZM4 19H6V17H4V19ZM6 15H4V13H6V15ZM4 11H6V9H4V11ZM6 7H4V5H6V7ZM8 19H10V17H8V19ZM10 15H8V13H10V15ZM8 11H10V9H8V11ZM10 7H8V5H10V7ZM20 19V9H12V11H14V13H12V15H14V17H12V19H20ZM18 11H16V13H18V11ZM16 15H18V17H16V15Z" fill="currentColor"/>',
        width: 24,
        height: 24,
      },
      certification: {
        body: '<path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M17 6.5H20C21.11 6.5 22 7.39 22 8.5V19.5C22 20.61 21.11 21.5 20 21.5H4C2.89 21.5 2 20.61 2 19.5V8.5C2 7.39 2.89 6.5 4 6.5H7V4.5C7 3.39 7.89 2.5 9 2.5H15C16.11 2.5 17 3.39 17 4.5V6.5ZM15 4.5H9V6.5H15V4.5ZM20 19.5H4V17.5H20V19.5ZM4 14.5H20V8.5H17V10.5H15V8.5H9V10.5H7V8.5H4V14.5Z" fill="currentColor"/>',
        width: 24,
        height: 24,
      },
      partner: {
        body: '<path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M11 15H7C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15ZM17 7H13V9H17C18.65 9 20 10.35 20 12C20 13.65 18.65 15 17 15H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7ZM16 11H8V13H16V11Z" fill="currentColor"/>',
        width: 24,
        height: 24,
      },
      laboratory: {
        body: '<path xmlns="http://www.w3.org/2000/svg" d="M5 21C4.15 21 3.54583 20.6208 3.1875 19.8625C2.82917 19.1042 2.91667 18.4 3.45 17.75L9 11V5H8C7.71667 5 7.47917 4.90417 7.2875 4.7125C7.09583 4.52083 7 4.28333 7 4C7 3.71667 7.09583 3.47917 7.2875 3.2875C7.47917 3.09583 7.71667 3 8 3H16C16.2833 3 16.5208 3.09583 16.7125 3.2875C16.9042 3.47917 17 3.71667 17 4C17 4.28333 16.9042 4.52083 16.7125 4.7125C16.5208 4.90417 16.2833 5 16 5H15V11L20.55 17.75C21.0833 18.4 21.1708 19.1042 20.8125 19.8625C20.4542 20.6208 19.85 21 19 21H5ZM7 18H17L13.6 14H10.4L7 18ZM5 19H19L13 11.7V5H11V11.7L5 19Z" fill="currentColor"/>',
        width: 24,
        height: 24,
      },
    },
  })
})
